import PropTypes from 'prop-types'
import UsersFilter from '@tabeeb/modules/forms/components/UsersFilter'
import FormsFilterContainer from '../../containers/FormsFilterContainer'
import './styles.less'

const FilterPanel = ({ readonly = false }) => {
  return (
    <div className='forms-filters'>
      <UsersFilter disabled={readonly} />
      <FormsFilterContainer readonly={readonly} />
    </div>
  )
}

FilterPanel.propTypes = {
  readonly: PropTypes.bool,
}

export default FilterPanel
